<!-- eslint-disable max-len -->
<template>
  <div
    class="
      block
      fixed
      left-0
      top-0
      w-full
      h-full
      p-4
      overflow-auto
      black-overlay
      bewerbung-block
    "
  >
    <div
      class="relative w-full bg-white rounded-2xl overflow-hidden model-block"
    >
      <div
        class="
          flex
          items-center
          justify-end
          relative
          w-full
          bg-darkgreen
          p-4
          top-block
        "
      >
        <a class="close text-right" @click="$emit('hideMe')">
          <svg
            class="w-4 h-4"
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.1622 12.1737C11.0301 12.1706 10.9047 12.1153 10.8132 12.02L6.00008 7.20689L1.18693 12.02C1.14032 12.068 1.08456 12.1062 1.02294 12.1322C0.961323 12.1583 0.895103 12.1717 0.828203 12.1717C0.728696 12.1717 0.631458 12.142 0.548932 12.0864C0.466406 12.0308 0.402343 11.9518 0.364942 11.8596C0.32754 11.7674 0.3185 11.6662 0.338978 11.5688C0.359456 11.4714 0.408521 11.3823 0.479896 11.313L5.29305 6.49986L0.479896 1.68671C0.43191 1.64063 0.393599 1.58545 0.367208 1.52439C0.340816 1.46332 0.326874 1.3976 0.326198 1.33109C0.325521 1.26457 0.338125 1.19858 0.363269 1.13699C0.388414 1.0754 0.425594 1.01945 0.472633 0.972414C0.519672 0.925375 0.575624 0.888193 0.637212 0.863049C0.6988 0.837904 0.764786 0.825301 0.831306 0.825977C0.897825 0.826653 0.963542 0.840596 1.02461 0.866988C1.08567 0.893379 1.14085 0.93169 1.18693 0.979675L6.00008 5.79283L10.8132 0.979675C10.8593 0.93169 10.9145 0.893379 10.9755 0.866988C11.0366 0.840596 11.1023 0.826655 11.1688 0.825979C11.2354 0.825302 11.3014 0.837906 11.3629 0.86305C11.4245 0.888195 11.4805 0.925375 11.5275 0.972414C11.5746 1.01945 11.6117 1.0754 11.6369 1.13699C11.662 1.19858 11.6746 1.26457 11.674 1.33109C11.6733 1.3976 11.6593 1.46332 11.6329 1.52439C11.6066 1.58545 11.5682 1.64063 11.5203 1.68671L6.70711 6.49986L11.5203 11.313C11.593 11.3828 11.6429 11.4729 11.6635 11.5716C11.6841 11.6702 11.6744 11.7728 11.6357 11.8659C11.597 11.9589 11.531 12.0381 11.4466 12.093C11.3621 12.148 11.2629 12.1761 11.1622 12.1737Z"
              fill="#fff"
            />
          </svg>
        </a>
      </div>
      <div class="block relative model-body">
        <div class="block pl-1 pr-1">
          <div class="block relative pt-2 pb-2 form-block">
            <div class="sign_contract_block">
              <div class="body_inner">
                <div class="checkerroe_block">
                  <h4 class="text-left mb-2">
                    {{ $t("pages.cookie_alert.privacy_note.header") }}
                  </h4>
                  <p class="text-left">
                    {{ $t("pages.cookie_alert.privacy_note.parts[0].header") }}
                  </p>
                  <p class="text-left font-normal mt-0.5">
                    {{ $t("pages.cookie_alert.privacy_note.parts[0].text1") }}
                  </p>
                  <p class="text-left font-normal mt-0.5">
                    {{ $t("pages.cookie_alert.privacy_note.parts[0].text2") }}
                  </p>

                  <p class="text-left mt-3">
                    {{ $t("pages.cookie_alert.privacy_note.parts[1].header") }}
                  </p>
                  <p class="text-left font-normal mt-0.5">
                    {{ $t("pages.cookie_alert.privacy_note.parts[1].text1") }}
                  </p>
                  <p class="text-left font-normal mt-0.5">
                    {{ $t("pages.cookie_alert.privacy_note.parts[1].text2") }}
                  </p>
                  <p class="text-left font-normal mt-0.5">
                    {{ $t("pages.cookie_alert.privacy_note.parts[1].text3") }}
                  </p>
                  <p class="text-left font-normal mt-0.5">
                    {{ $t("pages.cookie_alert.privacy_note.parts[1].text4") }}
                  </p>

                  <p class="text-left mt-3">
                    {{ $t("pages.cookie_alert.privacy_note.parts[2].header") }}
                  </p>
                  <p
                    class="text-left font-normal mt-0.5"
                    v-html="
                      $t('pages.cookie_alert.privacy_note.parts[2].text1')
                    "
                  ></p>
                  <p
                    class="text-left font-normal mt-0.5"
                    v-html="
                      $t('pages.cookie_alert.privacy_note.parts[2].text2')
                    "
                  ></p>
                  <p
                    class="text-left font-normal mt-0.5"
                    v-html="
                      $t('pages.cookie_alert.privacy_note.parts[2].text3')
                    "
                  ></p>
                  <p
                    class="text-left font-normal mt-0.5"
                    v-html="
                      $t('pages.cookie_alert.privacy_note.parts[2].text4')
                    "
                  ></p>

                  <p class="text-left mt-3">
                    {{ $t("pages.cookie_alert.privacy_note.parts[3].header") }}
                  </p>
                  <p class="text-left font-normal mt-0.5">
                    {{ $t("pages.cookie_alert.privacy_note.parts[3].text1") }}
                  </p>
                  <p class="text-left font-normal mt-0.5">
                    {{ $t("pages.cookie_alert.privacy_note.parts[3].text2") }}
                  </p>
                  <p class="text-left font-normal mt-0.5">
                    {{ $t("pages.cookie_alert.privacy_note.parts[3].text3") }}
                  </p>
                  <p
                    class="text-left font-normal"
                    v-html="
                      $t('pages.cookie_alert.privacy_note.parts[3].text4')
                    "
                  ></p>
                  <p
                    class="text-left font-normal"
                    v-html="
                      $t('pages.cookie_alert.privacy_note.parts[3].text5')
                    "
                  ></p>
                  <p
                    class="text-left font-normal"
                    v-html="
                      $t('pages.cookie_alert.privacy_note.parts[3].text6')
                    "
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
</style>
